import { useState } from "react";
import PortraitAnalysisDisplay from "./PortraitAnalysisDisplay";
import PortraitAnalysisEditing from "./PortraitAnalysisEditing";

const PortraitAnalysisContainer = ({
  portraitData,
  creationControlsLocked,
  setCreationControlsLocked,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  return isEditing ? (
    <PortraitAnalysisEditing
      portraitData={portraitData}
      setIsEditing={setIsEditing}
      setCreationControlsLocked={setCreationControlsLocked}
    />
  ) : (
    <PortraitAnalysisDisplay
      portraitData={portraitData}
      setIsEditing={setIsEditing}
      creationControlsLocked={creationControlsLocked}
      setCreationControlsLocked={setCreationControlsLocked}
    />
  );
};

export default PortraitAnalysisContainer;
